// src/components/Navigation/TopPanel.tsx
import React, { useState } from 'react';
import { useDialog } from '../../context/DialogContext'; 

export const TopPanel: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { showDialog } = useDialog();

  const handleMenuClick = (page: string) => {
    setMenuOpen(false);
    showDialog(page);
  };

  return (
    <div className="top-panel">
      <div className="top-panel-content">
        <div className="company-info">
          <h1>AiGrids</h1>
          <span className="company-subtitle">Intelligent spatial interpolation</span>
        </div>
        
        <div className="menu-container">
          <button 
            className="menu-trigger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          {menuOpen && (
            <div className="menu-dropdown">
              <button onClick={() => handleMenuClick('about')}>
                About
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};